import { TabFormContainer } from '@adista/window-kit-ui';
import { ReplaySubject, Observable, EMPTY } from 'rxjs';
import { ApiModel } from '@adista/common';
import { tap, mergeMap } from 'rxjs/operators';
import { OnInit } from '@angular/core';


export abstract class CustomTabFormContainer extends TabFormContainer implements OnInit {
  public mainItem: ReplaySubject<ApiModel> = new ReplaySubject<ApiModel>(1);

  ngOnInit(): void {
    super.ngOnInit();
  }

  public loadAll(): void {}
}
